import { set } from '@vue/composition-api'
import httpService from '@/core/http-service'
import _ from 'lodash'
import useNodeHierarchy from './useNodeHierarchy'
import useNodeSearch from './useNodeSearch'

export default function useNodeData(preSelections = undefined, baseurl = 'vehicle/selector/') {
  const hierarchy = useNodeHierarchy(getNodeData)
  const search = useNodeSearch()

  async function getNodeData(code = 'fordonNNoder') {
    const { data } = await httpService.get(`${baseurl}${code}`)
    return data
  }

  async function initializeNodeData(codeOrCodes = preSelections) {
    const initialData = await getNodeData()
    set(hierarchy.nodeData.value, 0, { node: { code: 'root' }, children: initialData })

    if (codeOrCodes) {
      if(_.isArray(codeOrCodes)) {
        await hierarchy.prePopulateSelections(codeOrCodes)
      } else {
        const codes = await hierarchy.getNodeCodeHierarchy(codeOrCodes)
        await hierarchy.prePopulateSelections(codes)
      }
    }

    hierarchy.selectedNodeData.value = _.cloneDeep(hierarchy.nodeData.value)
    hierarchy.initialized.value = true
  }

  async function handleSelection(selection) {
    function extractNextLevelCodes(data) {
      function getCodes(node) {
        return node ? [node.code, ...getCodes(node.nextLevel)] : []
      }

      return _.flatMap(data, item => getCodes(item.nextLevel))
    }
    search.clearSearchOptions()
    hierarchy.resetLowerLevels(0)
    const codes = extractNextLevelCodes(selection)
    hierarchy.prePopulateSelections(codes)
  }

  async function addNode(params, key) {
    await httpService.put('my-machines/machine-models', params)
    const data = await getNodeData(params.parentCode || 'fordonNNoder')
    const newlyAddedNode = _.find(data, node => node.name === params.name)
    hierarchy.nodeData.value[key].children = data
    hierarchy.addLevel(newlyAddedNode, key)
  }

  return {
    ...hierarchy,
    ...search,
    initializeNodeData,
    handleSelection,
    addNode
  }
}
